import { Controller, useForm, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue,
} from '@/components/ui/select';
import { Datasource } from '@/shared/types/collections';

interface MoveToFolderProps {
  datasources: Datasource[] | undefined;
  onSubmit: (data: Form) => void;
}

interface Form {
  datasource_id: string;
}

export const MoveToFolder = ({ datasources, onSubmit }: MoveToFolderProps) => {
  const { handleSubmit, control } = useForm<Form>({ mode: 'onChange', defaultValues: {} });
  const datasourceId = useWatch({ control, name: 'datasource_id' });

  const { t } = useTranslation();
  return (
    <div className="flex min-w-80 flex-col items-start justify-start gap-2 p-2">
      <p className="px-1 text-sm font-semibold">{t('collections.move_to_folder')}</p>
      <div className="mt-3 mb-3 w-full p-1">
        <Controller
          name="datasource_id"
          control={control}
          render={({ field }) => (
            <Select onValueChange={field.onChange} value={field.value}>
              <SelectTrigger>
                <SelectValue placeholder={`${t('common.select')}...`} />
              </SelectTrigger>
              <SelectContent>
                {datasources?.map((datasource) => (
                  <SelectItem key={datasource.datasource_id} value={datasource.datasource_id}>
                    {datasource.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          )}
        />
      </div>

      <Button
        size="sm"
        onClick={handleSubmit(onSubmit)}
        className="w-full"
        disabled={!datasourceId}
      >
        {t('common.move')}
      </Button>
    </div>
  );
};
